import { useEffect, useState, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import Pagination from "../../../../components/Pagination";
import api from "../../../../api/api";
import * as bootstrap from "bootstrap";
import BackButton from "../../../../components/BackButton";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";
import "../../Common/form.css";
 
const ExchangeRate = () => {
  const [exchangeRate, setExchangeRate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
 
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [newRate, setNewRate] = useState("");
  const [newRateUSD, setNewRateUSD] = useState("");
 
  const filteredData = useMemo(() => {
    return exchangeRate.filter(
      (exrate) =>
        exrate.country_name?.toLowerCase().includes(search.toLowerCase()) ||
        exrate.currency_name?.toLowerCase().includes(search.toLowerCase())||
        exrate.country_code?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [exchangeRate, search]);
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredData, 5);
 
  const fetchExchangeRates = async () => {
    try {
      setLoading(true);
      const response = await api.get("/master-data/exchange-rates");
      setExchangeRate(response.data);
    } catch (err) {
      setError("Failed to fetch exchange rates");
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    fetchExchangeRates();
  }, []);
 
  useEffect(() => {
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    const tooltips = tooltipTriggerList.map((el) => new bootstrap.Tooltip(el));
    return () => tooltips.forEach((t) => t.dispose());
  }, [currentItems]);
 
  const handleEditClick = async (item) => {
    try {
      setSelectedCurrency(item);
      setNewRate(item.rate_in_INR || "");
  setNewRateUSD(item.rate_in_USD || "");
      const modalEl = document.getElementById("editModal");
      const modal = new bootstrap.Modal(modalEl);
      modal.show();
    } catch (err) {
      alert("Could not load details.");
    }
  };
 
  const handleSubmit = async () => {
    if (!selectedCurrency || !newRate) return;
    try {
      await api.put(
        `/master-data/exchange-rates/${selectedCurrency.exchange_rate_id}`,
        {
          rate_in_INR: newRate,
        },
        
      );
 
      setExchangeRate((prev) =>
        prev.map((row) =>
          row.exchange_rate_id === selectedCurrency.exchange_rate_id
            // ? { ...row, rate_in_INR: newRate }
         
            // : row,
             ? {
        ...row,
        rate_in_INR: newRate,
        rate_in_USD: newRateUSD,
      }
    : row,
        ),
      );
 
      bootstrap.Modal.getInstance(document.getElementById("editModal")).hide();
    } catch (err) {
      console.error("Update failed", err);
    }
  };
 
  const handleStarClick = async (item) => {
    try {
      await api.put(
        `/master-data/exchange-rates/${item.exchange_rate_id}/favorite`,
      );
      setExchangeRate((prev) =>
        prev.map((row) =>
          row.exchange_rate_id === item.exchange_rate_id
            ? { ...row, is_fav: !row.is_fav }
            : row,
        ),
      );
    } catch (err) {
      alert("Could not update favorite status.");
    }
  };
 
  const columns = [
    { label: "Country Name", accessor: "country_name" },
    { label: "Currency Name", accessor: "currency_name" },
    { label: "Currency Code", accessor: "country_code" },
    { label: "Rate in INR", accessor: "rate_in_INR" },
     { label: "Rate in USD", accessor: "rate_in_USD" },
    {
      label: "Edit",
      render: (row) => (
        <EditIcon
          onClick={() => handleEditClick(row)}
          style={{ cursor: "pointer", color: "#1e305e" }}
        />
      ),
    },
    {
      label: "Favorite",
      render: (row) =>
        row.is_fav ? (
          <StarIcon
            onClick={() => handleStarClick(row)}
            style={{ cursor: "pointer", color: "#1e305e" }}
          />
        ) : (
          <StarBorderIcon
            onClick={() => handleStarClick(row)}
            style={{ cursor: "pointer", color: "#1e305e" }}
          />
        ),
    },
  ];
 
  if (error) return <div className="alert alert-danger m-3">{error}</div>;
 
  return (
    <>
      <BackButton />
      <div className="mb-3 d-flex align-items-center position-relative">
        <input
          type="text"
          className="form-control"
          placeholder="Search by country or currency..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            goToPage(1);
          }}
        />
        {search && (
          <CancelIcon
            className="position-absolute"
            onClick={() => setSearch("")}
            style={{ right: "15px", cursor: "pointer", color: "#6c757d" }}
          />
        )}
      </div>
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No exchange rates found."
          itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
 
      <div
        className="modal fade"
        id="editModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Exchange Rate</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              {selectedCurrency && (
                <>
                  <p>
                    <strong>Country:</strong> {selectedCurrency.country_name}
                  </p>
                  <p>
                    <strong>Currency:</strong> {selectedCurrency.currency_name}{" "}
                    ({selectedCurrency.country_code})
                  </p>
                  <div className="mt-3">
                    <label className="form-label">Rate in INR</label>
                    <input
                      type="number"
                      className="form-control"
                      value={newRate}
                      onChange={(e) => setNewRate(e.target.value)}
                    />
                  </div>
                   <div className="mt-3">
                    <label className="form-label">Rate in USD</label>
                    <input
                      type="number"
                      className="form-control"
                    value={newRateUSD}
                      onChange={(e) => setNewRateUSD(e.target.value)}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                Update Rate
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
 
export default ExchangeRate;